import React from "react";
const logo = "/assets/img/logo/Logo.png";

function Footer() {
  return (
    <footer className="footer footer-style-4">
      <div className="container">
        <div className="widget-wrapper">
          <div className="row">
            {/* LOGO + SOCIAL */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget wow fadeInUp" data-wow-delay=".2s">
                <div className="logo">
                  <a href="#0">
                    <img src={logo} alt="Logo" />
                  </a>
                </div>

                <p className="desc">
                  Your journey to a higher score begins the moment you decide to
                  take preparation seriously.
                </p>

                <ul className="socials">
                  <li>
                    <a href="#0">
                      <i className="lni lni-facebook-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i className="lni lni-twitter-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i className="lni lni-instagram-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i className="lni lni-linkedin-original"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* QUICK LINKS */}
            <div className="col-xl-2 offset-xl-1 col-lg-2 col-md-6 col-sm-6">
              <div className="footer-widget wow fadeInUp" data-wow-delay=".3s">
                <h6>Quick Link</h6>

                <ul className="links">
                  <li>
                    <a href="#home">Home</a>
                  </li>
                  <li>
                    <a href="#journey">Journey</a>
                  </li>
                  <li>
                    <a href="#about">About</a>
                  </li>
                  <li>
                    <a href="#features">Features</a>
                  </li>
                  <li>
                    <a href="#courses">Courses</a>
                  </li>
                  <li>
                    <a href="#contact">Contact</a>
                  </li>
                  <li>
                    <a href="#0">Login</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* SERVICES */}
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
              <div className="footer-widget wow fadeInUp" data-wow-delay=".4s">
                <h6>Services</h6>

                <ul className="links">
                  <li>
                    <a href="#0">Digital Tests</a>
                  </li>
                  <li>
                    <a href="#0">SAT</a>
                  </li>
                  <li>
                    <a href="#0">APs</a>
                  </li>
                  <li>
                    <a href="#0">ACT</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* DOWNLOAD */}
            <div className="col-xl-3 col-lg-3 col-md-6">
              <div className="footer-widget wow fadeInUp" data-wow-delay=".5s">
                <h6>Download App</h6>

                <ul className="download-app">
                  <li>
                    <a href="#0">
                      <span className="icon">
                        <i className="lni lni-apple"></i>
                      </span>
                      <span className="text">
                        Download on the <b>App Store</b>
                      </span>
                    </a>
                  </li>

                  <li>
                    <a href="#0">
                      <span className="icon">
                        <i className="lni lni-play-store"></i>
                      </span>
                      <span className="text">
                        GET IT ON <b>Play Store</b>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="copyright-wrapper wow fadeInUp" data-wow-delay=".2s">
          <p>Design and Developed by EduSkillPrep</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
